module.exports = __webpack_public_path__ + "static/img/card_4_11.984be49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/card_4_11.png
// module id = Zltv
// module chunks = 0